import { lazy, Suspense, type ComponentType } from 'react';
import type { RouteRecord } from 'vite-react-ssg';
import Layout from './Layout';
import Index from './pages/Index';
import { ProtectedRoute } from './components/ProtectedRoute';

const PageLoader = () => (
  <div className="min-h-[50vh] flex items-center justify-center">
    <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-primary" />
  </div>
);

function lazyPage(importFn: () => Promise<{ default: ComponentType }>) {
  const LazyComponent = lazy(importFn);
  return (
    <Suspense fallback={<PageLoader />}>
      <LazyComponent />
    </Suspense>
  );
}

export const routes: RouteRecord[] = [
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <Index /> },
      { path: 'aanbod', element: lazyPage(() => import('./pages/Aanbod')) },
      { path: 'summer-read', element: lazyPage(() => import('./pages/SummerRead')) },
      {
        path: 'leergang-systemisch-leiderschap',
        element: lazyPage(() => import('./pages/LeergangOnderstroom')),
      },
      {
        path: 'organisatieopstellingen',
        element: lazyPage(() => import('./pages/Organisatieopstellingen')),
      },
      { path: 'teamcoaching', element: lazyPage(() => import('./pages/Teamcoaching')) },
      {
        path: 'opleidingstrajecten',
        element: lazyPage(() => import('./pages/Opleidingstrajecten')),
      },
      {
        path: 'familieopstellingen',
        element: lazyPage(() => import('./pages/FamilieOpstelling')),
      },
      { path: '1-op-1', element: lazyPage(() => import('./pages/EenOpEen')) },
      { path: 'over', element: lazyPage(() => import('./pages/Over')) },
      { path: 'privacy-en-cookies', element: lazyPage(() => import('./pages/PrivacyEnCookies')) },
      { path: 'nieuwsbrief', element: lazyPage(() => import('./pages/Nieuwsbrief')) },
      { path: 'contact', element: lazyPage(() => import('./pages/Contact')) },
      { path: 'koop-strippenkaart', element: lazyPage(() => import('./pages/KoopStrippenkaart')) },
      { path: 'themadag/burn-out-organisaties', element: lazyPage(() => import('./pages/Themadag')) },
      { path: 'agenda', element: lazyPage(() => import('./pages/Agenda')) },
      { path: 'login', element: lazyPage(() => import('./pages/Login')) },
      { path: 'signup', element: lazyPage(() => import('./pages/Signup')) },
      {
        path: 'mijn-strippenkaart',
        element: (
          <ProtectedRoute>{lazyPage(() => import('./pages/MijnStrippenkaart'))}</ProtectedRoute>
        ),
      },
      {
        path: 'admin',
        element: <ProtectedRoute>{lazyPage(() => import('./pages/Admin'))}</ProtectedRoute>,
      },
      { path: '*', element: lazyPage(() => import('./pages/NotFound')) },
    ],
  },
];
